@if (visible()) {
<div class="jk-component w-full">
  <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
    [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  <div class="jk-field-lable">
    <!-- <dx-lookup [ngClass]="jkClass" [showClearButton]="showClearButton" [dataSource]="items" [valueExpr]="valueExpr"
      [displayExpr]="displayExpr" [(ngModel)]="value" (valueChange)="onValueChange($event)"
      >
    </dx-lookup> -->
  </div>

</div>
}
<!--
<ion-grid enabled>
  <ion-row>
    @if (displayLabel) {
    <ion-col size="auto" class="jk-field-lable">
      <ion-label>
        {{label()}}
      </ion-label>
      @if (required) {
      <ion-label style="color:red">*</ion-label>
      }
    </ion-col>
    }
    <ion-col>
      <dx-lookup [showClearButton]="showClearButton" [dataSource]="items" [valueExpr]="valueExpr"
        [displayExpr]="displayExpr" [(value)]="value">
      </dx-lookup>
    </ion-col>
  </ion-row>
</ion-grid> -->